import React from 'react';
import { PartnerNode, Loader } from 'components';
import { PartnerService } from 'services';
import { useQuery } from '@tanstack/react-query';

interface OrganizationChartProps {
	selectedPartnerId?: number;
	setPartnerId: (partnerId?: number) => void;
}

export const OrganizationChart = ({ selectedPartnerId, setPartnerId }: OrganizationChartProps) => {
	const { data: nodes, isFetching, isLoading } = useQuery({
		queryKey: ['organization-chart-nodes', selectedPartnerId],
		queryFn: async () => await PartnerService.getOrganizationChartForUser(selectedPartnerId || 0)
	})
	return (
		<>
			<Loader active={(isFetching || isLoading)} />
			<PartnerNode setPartnerId={setPartnerId} nodes={nodes ? [nodes] : []} />
		</>
	)
}
